"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isObject(el) {
    return typeof el === "object" && el !== null && el.constructor && el.constructor === Object;
}
exports.isObject = isObject;
exports.safeKeyRegex = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
function describe(val) {
    if (typeof val === "function") {
        if (typeof val.toSpec === "function") {
            return describe(val.toSpec());
        }
        if (typeof val.toSpecString === "function") {
            return val.toSpecString();
        }
        return "function";
    }
    if (val === undefined) {
        return "undefined";
    }
    if (Array.isArray(val)) {
        return "[" + val.map(describe).join(", ") + "]";
    }
    if (isObject(val)) {
        var content = Object.keys(val)
            .map(function (k) { return (exports.safeKeyRegex.test(k) ? k : JSON.stringify(k)) + ": " + describe(val[k]); })
            .join(", ");
        return content.length > 0 ? "{ " + content + " }" : "{}";
    }
    return JSON.stringify(val);
}
exports.describe = describe;
